import React from 'react';
import { Link } from 'react-router-dom';
import { useShop } from '../context/ShopContext';
import { useTheme } from '../context/ThemeContext';

const SHOP_NAME = process.env.REACT_APP_SHOP_NAME || 'Shop';

export default function Footer({ shopName: propShopName }) {
    const { shopName: contextShopName } = useShop();
    const { themeData } = useTheme();
    const displayName = propShopName || contextShopName || SHOP_NAME;
    const footerLinks = themeData?.customization?.footer_links || [];
    const customLinks = footerLinks.filter(link => link?.label?.trim() && link?.url?.trim());

    return (
        <footer className="border-t py-8 mt-10 sm:mt-12 pb-[max(2rem,calc(env(safe-area-inset-bottom,0px)+1.25rem))] sm:pb-8">
            <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-muted-foreground text-sm">
                        © {new Date().getFullYear()} {displayName}. Powered by instaGshop
                    </p>
                    <div className="flex items-center gap-4 text-sm text-muted-foreground flex-wrap justify-center">
                        {customLinks.map((link, i) => (
                            <a key={i} href={link.url} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                                {link.label}
                            </a>
                        ))}
                        {customLinks.length > 0 && <span>•</span>}
                        <Link to="/contact" className="hover:text-primary transition-colors" data-testid="footer-contact-link">
                            Επικοινωνία
                        </Link>
                        <span>•</span>
                        <Link to="/terms" className="hover:text-primary transition-colors" data-testid="footer-terms-link">
                            Terms of Service
                        </Link>
                        <span>•</span>
                        <Link to="/privacy" className="hover:text-primary transition-colors" data-testid="footer-privacy-link">
                            Privacy Policy
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
